import toast from "react-hot-toast";
import { uploadFileApi } from "../api/upload-api";

/**
 * Converts a File object to a base64 string.
 * @param {File} file 
 * @returns {Promise<string>}
 */
export const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });
};

/**
 * Uploads a file (image or video) to the server using ImageKit.
 * @param {File|string} file - The file object or base64 string to upload.
 * @param {string} folder - The folder name in ImageKit.
 * @param {Function} onProgress - Progress callback.
 * @returns {Promise<string|null>} - Returns the file URL if successful, otherwise null.
 */
export const uploadFile = async (file, folder = 'upload', onProgress) => {
    if (!file) return null;
    try {
        let base64File = file;
        
        // Convert to base64 if it's a File object
        if (file instanceof File || file instanceof Blob) {
            base64File = await fileToBase64(file);
        }

        const data = await uploadFileApi(base64File, folder, onProgress);
        if (data.success) {
            toast.success("File uploaded successfully");
            return data.url;
        } else {
            toast.error(data.message || "Upload failed");
            return null;
        }
    } catch (error) {
        console.error("File upload error:", error);
        toast.error("File upload failed");
        return null;
    }
};


/**
 * Converts a File object to a Base64 string.
 * @param {File} file - The file to convert.
 * @returns {Promise<string>} - The Base64 string.
 */
export const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });
};
